import React from 'react';
import { Grid, Typography, Box, Tooltip, IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const RiskDetails = ({ riskFactorsMap, phoneId, getRiskLabel }) => {
	const riskData = riskFactorsMap[phoneId]?.data;

	if (!riskData) return null;

	const tooltipTexts = {
		lifetime: 'Shows how long the phone has been in active usage. Longer lifetime generally indicates better stability.',
		contactRisk: 'Indicates the risk level based on contact patterns and messaging frequency.',
		responseRisk: 'Shows the risk assessment based on message response rates and patterns.',
	};

	const riskDetailItem = (label, value, tooltipText) => (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				height: '100%',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: 0.5,
					mb: 1,
				}}
			>
				<Typography
					variant="caption"
					color="textSecondary"
					sx={{
						display: 'block',
						minHeight: '20px',
					}}
				>
					{label}
				</Typography>
				<Tooltip title={tooltipText} placement="top">
					<IconButton
						size="small"
						sx={{
							padding: 0,
							'& svg': {
								fontSize: '14px',
								color: 'text.secondary',
							},
						}}
					>
						<HelpOutlineIcon />
					</IconButton>
				</Tooltip>
			</Box>
			<Typography
				sx={{
					px: 2,
					py: 0.5,
					borderRadius: 1,
					bgcolor: getRiskLabel(value).color,
					color: 'white',
					display: 'inline-block',
					whiteSpace: 'nowrap',
					minWidth: '110px',
					textAlign: 'center',
				}}
			>
				{getRiskLabel(value).label}
			</Typography>
		</Box>
	);

	return (
		<Box sx={{ mt: 2, pt: 2, borderTop: '1px solid rgba(0, 0, 0, 0.12)' }}>
			<Typography variant="subtitle2" gutterBottom>
				Risk Details
			</Typography>
			<Grid
				container
				spacing={2}
				sx={{
					alignItems: 'flex-start',
					'& .MuiGrid-item': {
						display: 'flex',
						alignItems: 'stretch',
					},
				}}
			>
				<Grid item xs={4}>
					{riskDetailItem('Lifetime', riskData.life_time, tooltipTexts.lifetime)}
				</Grid>
				<Grid item xs={4}>
					{riskDetailItem('Contact Risk', riskData.riskFactorContacts, tooltipTexts.contactRisk)}
				</Grid>
				<Grid item xs={4}>
					{riskDetailItem('Response Risk', riskData.riskFactorResponse, tooltipTexts.responseRisk)}
				</Grid>
			</Grid>
		</Box>
	);
};

export default RiskDetails;
